import { StandingOrderOut } from '../../store/api';
import { DropDownMenu } from '../../shared/common/DropDownMenu';
import { useState } from 'react';

type Props = {
    readonly standingOrders: {
        readonly list: Array<StandingOrderOut>;
        readonly selected?: StandingOrderOut;
        readonly show: boolean;
    };
    readonly onStandingOrderChange: (standingOrder: StandingOrderOut) => void;
};

export const CheckoutStandingOrderDropDown = (props: Props) => {
    const [expanded, setExpanded] = useState(false);
    const standingOrders = props?.standingOrders?.list || [];
    const selectedStandingOrder = props.standingOrders?.selected;
    const label = selectedStandingOrder?.planName || '';

    return (
        <div>
            {standingOrders.length > 1 ? (
                <DropDownMenu
                    expanded={expanded}
                    onToggleClick={() => setExpanded(!expanded)}
                    align="left"
                    gap={3}
                    onClickOutside={() => setExpanded(false)}
                    label={label}
                    labelClassName="txt-normal"
                    className="just-dd fl-none account-dd"
                    showActiveArrow={false}
                >
                    {standingOrders.map((standingOrder, i) => {
                        const isActive = selectedStandingOrder === standingOrder;
                        const check = isActive ? <i className="material-icons">check</i> : null;
                        const highlightClass = isActive ? 'checked' : undefined;
                        return (
                            <li key={i}>
                                <a
                                    className={highlightClass}
                                    onClick={() => {
                                        props.onStandingOrderChange(standingOrder);
                                    }}
                                >
                                    <div className="txt-normal">{standingOrder.planName}</div>
                                    <div className="txt-smaller">{standingOrder.planId}</div>
                                    {check}
                                </a>
                            </li>
                        );
                    })}
                </DropDownMenu>
            ) : (
                label
            )}
            <div className="txt-smaller">{selectedStandingOrder?.planId || ''}</div>
        </div>
    );
};
